var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-muted"},[_c('h2',{staticClass:"mt-5 mb-2"},[_vm._v("Antworten")]),_c('pre',[_vm._v(_vm._s(_vm.answers))]),_c('h2',{staticClass:"mt-5 mb-2"},[_vm._v("Fragen")]),_c('pre',[_vm._v(_vm._s(_vm.questions))])])
}
var staticRenderFns = []

export { render, staticRenderFns }